export default {"src":"/_next/static/media/keyboard.ccca1fbe.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};